module.exports = __webpack_public_path__ + "img/sw-ys41.3a6f8750.jpg";